/**
 * Automy.Core.Model.Reporting.ReportingDatasetKeyKind
 * JSON `kind` on GET /report/config/catalog (string token).
 * Not an Enums.Reporting.Datasets member.
 */
export default Object.freeze({
  Static: 'static',
  ProcessFormData: 'process-form-data',
  DynamicEntity: 'dynamic-entity',
});
